import routes from './routes';
import httpClient, { isHttpError } from '../httpClient';

export async function getAllProaqPrecoCMED() {
  try {
    const response = await httpClient.get(routes.pesquisapreco);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    console.error('Erro ao obter lista de Registros:', error);
    throw error;
  }
}

export async function getPrecoCMEDsByProaqId(id: string) {
  try {
    const response = await httpClient.get(`/api/pesquisapreco/proaq/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter lista de Registros:', error);
    throw error;
  }
}

export async function getProaqPrecoCMED(id: string) {
  try {
    const response = await httpClient.get(`${routes.pesquisapreco}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Registro: ' + error);
  }
}

export const createPrecoCMED = async (data: any) => {
  try {
    const response = await httpClient.post(routes.pesquisapreco, data);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao criar o preço CMED.',
      );
    }
    throw error;
  }
};

export const updatePrecoCMED = async (id: number, data: any) => {
  try {
    const response = await httpClient.patch(
      `${routes.pesquisapreco}/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao atualizar o preço CMED.',
      );
    }
    throw error;
  }
};

export const deletePrecoCMED = async (id: number) => {
  try {
    const response = await httpClient.delete(`${routes.pesquisapreco}/${id}`);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao deletar o preço CMED.',
      );
    }
    throw error;
  }
};
